import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useApi } from '../api/useApi';

/**
 * "Today" entry point: resolves the most recent digest date and redirects to
 * it. That is whatever the digest list reports first — the assistant may not
 * have written a digest for the literal current day yet. Falls back to the
 * all-days list when there are no digests, or when the lookup fails.
 */
export function TodayPage() {
  const api = useApi();
  const [target, setTarget] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const { digests } = await api.listDigests();
        if (cancelled) return;
        // The digest list arrives newest-first, so the head is the latest day.
        const latest = digests[0]?.date;
        setTarget(latest ? `/digests/${latest}` : '/');
      } catch {
        if (!cancelled) setTarget('/');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [api]);

  if (!target) {
    return (
      <main className="mx-auto max-w-5xl px-4 py-8 text-muted-foreground sm:px-6">Loading…</main>
    );
  }
  return <Navigate to={target} replace />;
}
